<template>
  <section v-on:click="sectionClicked" class="features twoImage" :class="section.id">
    <div class="cnt">
      <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
      <div class="twoImg-cnt">
        <div class="twoImg-item" v-for="(item, i) in section.items" :key="i"
          :class="{video: item.media[lang] && item.media[lang].type === 'video'}">
          <div class="twoImg-img no-img" v-if="!item.media[lang]"></div>
          <div class="twoImg-img video" v-else-if="item.media[lang].type === 'video'"
            :style="{'background-image': `url(${item.media[lang].mainThumb})`}"
            v-on:click="openVideo(item)"></div>
          <div class="twoImg-img" v-else>
            <img :src="item.media[lang].imageLg">
          </div>
          <h4 v-if="item.title[lang]">{{item.title[lang]}}</h4>
          <p v-if="item.descriptions[lang]" v-html="item.descriptions[lang]"></p>
          <a :href="`${(item.url.substring(0,1) === '/') ? `/${langCode}${item.url}` : item.url}`"
            class="btn primary" v-if="item.buttonLabel[lang]">{{item.buttonLabel[lang]}}</a>
        </div>
      </div>
    </div>
    <VideoDialogLocal ref="videoDialogLocal"/>
  </section>
</template>

<script>
import VideoDialogLocal from '@/components/VideoDialogLocal.vue';

export default {
  name: 'home',
  props: ['section'],
  components: { VideoDialogLocal },
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    openVideo(item) {
      this.section.modalOpen = true;
      this.$refs.videoDialogLocal.open(item, () => {
        this.section.modalOpen = false;
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style lang="scss">
.twoImg-cnt{
  .twoImg-item{
    p{
      b{
        color: #E9134F;
      }
    }
  }
}
</style>

<style scoped lang="scss">
.twoImg-cnt{
  max-width: 1260px;
  margin: 0 auto;
  display: flex;
  padding: 60px 0 40px;
  @media (max-width: 940px) {
    display: block;
    padding-bottom: 10px;
  }
  @media (max-width: 680px) {
    margin: 0 20px;
  }
  .twoImg-item{
    text-align: center;
    width: 50%;
    box-sizing: border-box;
    padding: 0 80px;
    @media (max-width: 940px) {
      width: auto;
      margin: 0 0 100px;
    }
    @media (max-width: 680px) {
      padding: 0;
    }
    &:last-child{
      margin: 0;
    }
    h4{
      margin: 0 0 6px;
      font-size: 26px;
      font-weight: 600;
    }
    p{
      font-size: 20px;
      margin: 0 0 20px;
      @media (max-width: 680px) {
        line-height: 1.3;
        font-size: 18px;
      }
      b{
        color: #E9134F;
      }
    }
    .twoImg-img{
      margin: 0 0 40px;
      &.video{
        height: 300px;
        border-radius: 7px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        margin: 0 0 20px;
        transition: all .3s ease;
        position: relative;
        cursor: pointer;
        @media (max-width: 1240px) {
          height: 260px;
        }
        @media (max-width: 940px) {
          height: 46vw;
        }
        &:before{
          content: "";
          position: absolute;
          left: 50%; top: 50%;
          width: 54px; height: 54px;
          margin: -27px 0 0 -27px;
          border: #fff 2px solid;
          border-radius: 50%;
          background-image: url(../../assets/play-white.png);
          background-size: 26px auto;
          background-position: 15px 50%;
          background-repeat: no-repeat;
          opacity: .3;
          transition: all .3s ease;
        }
        &:hover{
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          &:before{
            opacity: .7;
          }
        }
      }
      img{
        height: 340px;
        margin: 0 auto;
        display: block;
        @media (max-width: 680px) {
          height: auto;
          width: 90%;
        }
      }
    }
    .btn{
      border-radius: 50px;
      display: inline-block;
      width: auto;
    }
    &.video{
      padding: 0 60px;
      @media (max-width: 680px) {
        padding: 0;
      }
      h4{
        font-size: 20px;
      }
    }
  }
}

/**
 * Custom
 *
 */
.twoImage.bye-cool-videos{
  background-color: #486cb1;
  color: #fff;
  padding: 0;
  margin: 200px 0;
  @media (max-width: 940px) {
    margin: 120px 0;
  }
  @media (max-width: 740px) {
    padding: 40px 0 0;
  }
  &:before{
    content: "";
    position: absolute;
    height: 200px; top: -200px;
    left: 0; right: 0;
    background-image: url(../../assets/blue-divider-top.png);
    background-size: 100% auto;
    background-position: bottom center;
    background-repeat: no-repeat;
  }
  &:after{
    content: "";
    position: absolute;
    height: 200px; bottom: -200px;
    left: 0; right: 0;
    background-image: url(../../assets/blue-divider-bottom.png);
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
  }
  .twoImg-cnt{
    padding: 60px 0 0;
    margin: 0;
    max-width: none;
  }
}
</style>
